// // src/app/headerpage/headerpage.component.ts
// import { Component, OnInit, OnDestroy } from '@angular/core';
// import { NgToastService } from 'ng-angular-popup';
// import Swal from 'sweetalert2';
// import { AuthService } from '../services/auth.service';
// import { HomeService } from '../services/home.service';
// import { Subscription, interval } from 'rxjs';
// import { ConfigService } from '../services/config.service';
// import { NotificationUpdateService } from '../services/notification-update.service';

// @Component({
//   selector: 'app-headerpage',
//   templateUrl: './headerpage.component.html',
//   styleUrls: ['./headerpage.component.scss'],
// })
// export class HeaderpageComponent implements OnInit, OnDestroy {
//   showForm: boolean = false;
//   isLogin: boolean = false;
//   userLog: any = null;
//   notLength: number = 0; // Changed to number with default 0
//   private pollingSubscription!: Subscription;
//   private notificationUpdateSubscription!: Subscription;
//   headerbackgroundColor!: string;
//   loginButtonColor!: string;
//   activeColor!: string;
//   activeBorderColor!: string;
//   hoverColor!: string;
//   logo: any;
//   onClickActiveColor: any;
//   router: any;

//   constructor(
//     private toast: NgToastService,
//     private auth: AuthService,
//     private home: HomeService,
//     private configService: ConfigService,
//     private notificationUpdateService: NotificationUpdateService
//   ) {}

//   ngOnInit(): void {
    
//     // Check for any of the possible token keys
//     const tokenKeys = ['user-access', 'token', 'user-token-goldBharatFirst'];
//     let userToken = null;
    
//     for (const key of tokenKeys) {
//       userToken = localStorage.getItem(key);
//       if (userToken) break;
//     }
    
//     this.isLogin = userToken !== null;
    
//     if (this.isLogin) {
//       this.loadUserInfo();
//       this.getNotification(); // Initial fetch
//       this.startPolling(); // Start polling every 2 seconds
      
//       // Subscribe to notification read events for instant updates
//       this.notificationUpdateSubscription = this.notificationUpdateService.notificationRead$
//         .subscribe(() => {
//           console.log('Notification read event received, refreshing count');
//           this.getNotification(); // Refresh count instantly
//         });
//     }

//     const config = this.configService.getConfig();
//     if (config && config.theme && config.theme.headerBackgroundColor && config.theme.loginButtonColor && config.theme.activeColor && config.theme.activeBorderColor && config.theme.hoverColor  &&  config.images && config.images.logo) {
//       this.headerbackgroundColor = config.theme.headerBackgroundColor;
//       this.loginButtonColor = config.theme.loginButtonColor;
//       this.activeColor = config.theme.activeColor;
//       this.activeBorderColor = config.theme.activeBorderColor;
//       this.hoverColor = config.theme.hoverColor;
//       this.onClickActiveColor = config.theme;
//       this.logo = config.images.logo;
//       console.log("image", this.logo);
//     } else {
//       this.headerbackgroundColor = '#FCF3E1'; // Default color if config is not available
//       this.loginButtonColor = '#e1b737';
//     }

//     this.router.navigate(['/orders'], {
//   // queryParams: {
//   //   orderType: 'Coins',
    
//   // }
// });
//   }

//   ngOnDestroy(): void {
//     this.stopPolling();
//     if (this.notificationUpdateSubscription) {
//       this.notificationUpdateSubscription.unsubscribe();
//     }
//   }

//   toggleForm(): void {
//     this.showForm = !this.showForm;
//   }

//   private loadUserInfo(): void {
//     this.auth.userDetailGet().subscribe(
//       (res: any) => {
//         this.userLog = res.data;
//         console.log(this.userLog);
//         localStorage.setItem("userData", JSON.stringify(this.userLog));
//       },
//       (error: any) => {
//         console.error('Error fetching user details:', error);
//       }
//     );
//   }

//   private getNotification(): void {
//   this.home.getNotification().subscribe({
//     next: (res: any) => {
//       // Show total notifications count instead of unread
//       this.notLength = res.notifications?.length || 0;
//       console.log('Total notifications count:', this.notLength);
      
//       localStorage.setItem('notificationCount', this.notLength.toString());
//     },
//     error: (error) => {
//       console.error('Error fetching notifications:', error);
//     }
//   });
// }

//   private startPolling(): void {
//     this.pollingSubscription = interval(2000).subscribe(() => {
//       this.getNotification();
//     });
//   }

//   private stopPolling(): void {
//     if (this.pollingSubscription) {
//       this.pollingSubscription.unsubscribe();
//     }
//   }

//   logOut(): void {
//     Swal.fire({
//       title: 'Logout',
//       text: 'Are you sure you want to logout?',
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#073434',
//       cancelButtonColor: '#eb4034',
//       confirmButtonText: 'Ok',
//       cancelButtonText: 'Cancel',
//     }).then((result) => {
//       if (result.isConfirmed) {
//         // Remove all possible token keys on logout
//         const tokenKeys = ['user-access', 'token', 'user-token-goldBharatFirst'];
//         tokenKeys.forEach(key => localStorage.removeItem(key));
        
//         // Clear notification count
//         localStorage.removeItem('notificationCount');
        
//         this.toast.success({
//           detail: 'Success!',
//           summary: 'Logged out successfully!',
//         });
//         this.stopPolling();
//         window.location.reload();
//       }
//     });
//   }

//   // Public method to manually refresh notification count
//   public refreshNotificationCount(): void {
//     if (this.isLogin) {
//       this.getNotification();
//     }
//   }
// }

// src/app/headerpage/headerpage.component.ts
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';   // ← NavigationEnd import add cheయండి
import { NgToastService } from 'ng-angular-popup';
import Swal from 'sweetalert2';
import { AuthService } from '../services/auth.service';
import { HomeService } from '../services/home.service';
import { Subscription, interval } from 'rxjs';
import { ConfigService } from '../services/config.service';
import { NotificationUpdateService } from '../services/notification-update.service';

@Component({
  selector: 'app-headerpage',
  templateUrl: './headerpage.component.html',
  styleUrls: ['./headerpage.component.scss'],
})
export class HeaderpageComponent implements OnInit, OnDestroy {
  showForm: boolean = false;
  isLogin: boolean = false;
  userLog: any = null;
  notLength: number = 0;
  private pollingSubscription!: Subscription;
  private notificationUpdateSubscription!: Subscription;
  private routerSubscription!: Subscription;   // ← add this
  headerbackgroundColor!: string;
  loginButtonColor!: string;
  activeColor!: string;
  activeBorderColor!: string;
  hoverColor!: string;
  logo: any;
  onClickActiveColor: any;

  // ← NEW: controls hiding the toggler icon on gold-coins page
  isGoldCoinsPage: boolean = false;

  constructor(
    private toast: NgToastService,
    private auth: AuthService,
    private home: HomeService,
    private configService: ConfigService,
    private notificationUpdateService: NotificationUpdateService,
    private router: Router
  ) {}

  ngOnInit(): void {

    // ← NEW: track route changes to detect gold-coins page
    this.checkCurrentRoute(this.router.url);
    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.checkCurrentRoute(event.urlAfterRedirects);
      }
    });

    // Check for any of the possible token keys
    const tokenKeys = ['user-access', 'token', 'user-token-goldBharatFirst'];
    let userToken = null;

    for (const key of tokenKeys) {
      userToken = localStorage.getItem(key);
      if (userToken) break;
    }

    this.isLogin = userToken !== null;

    if (this.isLogin) {
      this.loadUserInfo();
      this.getNotification();
      this.startPolling();

      this.notificationUpdateSubscription = this.notificationUpdateService.notificationRead$
        .subscribe(() => {
          this.getNotification();
        });
    }

    const config = this.configService.getConfig();
    if (config && config.theme && config.theme.headerBackgroundColor && config.theme.loginButtonColor && config.theme.activeColor && config.theme.activeBorderColor && config.theme.hoverColor && config.images && config.images.logo) {
      this.headerbackgroundColor = config.theme.headerBackgroundColor;
      this.loginButtonColor = config.theme.loginButtonColor;
      this.activeColor = config.theme.activeColor;
      this.activeBorderColor = config.theme.activeBorderColor;
      this.hoverColor = config.theme.hoverColor;
      this.onClickActiveColor = config.theme;
      this.logo = config.images.logo;
    } else {
      this.headerbackgroundColor = '#FCF3E1';
      this.loginButtonColor = '#e1b737';
    }
  }

  // ← NEW: sets isGoldCoinsPage true whenever route is /gold-coins
  private checkCurrentRoute(url: string): void {
    this.isGoldCoinsPage = url.includes('/gold-coins');
  }

  ngOnDestroy(): void {
    this.stopPolling();
    if (this.notificationUpdateSubscription) {
      this.notificationUpdateSubscription.unsubscribe();
    }
    if (this.routerSubscription) {          // ← add this
      this.routerSubscription.unsubscribe();
    }
  }

  toggleForm(): void {
    this.showForm = !this.showForm;
  }

  private loadUserInfo(): void {
    this.auth.userDetailGet().subscribe(
      (res: any) => {
        this.userLog = res.data;
        console.log(this.userLog);
        localStorage.setItem("userData", JSON.stringify(this.userLog));
      },
      (error: any) => {
        console.error('Error fetching user details:', error);
      }
    );
  }

  private getNotification(): void {
    this.home.getNotification().subscribe({
      next: (res: any) => {
        this.notLength = res.unreadLength || 0;
        console.log('Unread Count:', this.notLength);
        console.log('Total Notifications:', res.notifications?.length || 0);
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

  private startPolling(): void {
    this.pollingSubscription = interval(2000).subscribe(() => {
      this.getNotification();
    });
  }

  private stopPolling(): void {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
    }
  }

  // Called when the user clicks the notification bell icon.
  // Calls markAsRead immediately so badge count clears right away,
  // then routerLink handles the navigation to /notifications.
  onNotificationClick(): void {
    if (!this.isLogin) {
      return;
    }
    this.home.notificationRead().subscribe({
      next: (res: any) => {
        console.log('Marked as read:', res);
        this.notLength = 0;
        this.notificationUpdateService.notifyNotificationRead();
      },
      error: (error) => {
        console.error('Error marking notifications as read:', error);
      }
    });
  }

  logOut(): void {
    debugger;
    Swal.fire({
      title: 'Logout',
      text: 'Are you sure you want to logout?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#073434',
      cancelButtonColor: '#eb4034',
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        // Remove all possible token keys on logout
        const tokenKeys = ['user-access', 'token', 'user-token-goldBharatFirst'];
        tokenKeys.forEach(key => localStorage.removeItem(key));

        // Clear notification count
        localStorage.removeItem('notificationCount');

        this.toast.success({
          detail: 'Success!',
          summary: 'Logged out successfully!',
           duration: 500,
        });
        this.stopPolling();
           setTimeout(() => {
        window.location.reload();
      }, 500);
      }
    });
  }

  // Public method to manually refresh notification count
  public refreshNotificationCount(): void {
    if (this.isLogin) {
      this.getNotification();
    }
  }
  
}